import axios, { AxiosError, AxiosPromise, AxiosRequestConfig, AxiosResponse } from "axios";

import { HttpError } from "./error";

export const onHttpSuccess = (response: AxiosResponse) => {
  if (!response.data) {
    response.data = {};
  }
  return response;
};

export const onHttpFailure = (error: AxiosError) => {
  if (error.response) {
    const { data: payload, status, statusText } = error.response;
    return new HttpError({ payload, status, message: statusText });
  }

  const { message } = error;

  if (axios.isCancel(error)) {
    // Canceled by user action
    return new HttpError({ message, canceled: true, network: true });
  }

  if (error.code === "ECONNABORTED") {
    // Timeout exceeded
    return new HttpError({ message, timeout: true, network: true });
  }

  // Network error
  return new HttpError({ message, network: false });
};

axios.interceptors.response.use(
  response => Promise.resolve(onHttpSuccess(response)),
  error => Promise.reject(onHttpFailure(error)),
);

export const execute = <T>(url: string, options: AxiosRequestConfig = {}): AxiosPromise<T> => {
  return axios(url, options);
};

export const isCanceledHttpRequest = (error: unknown): boolean => {
  return axios.isCancel(error) || (error instanceof HttpError && error.canceled);
};
